import TopUpdateBar from './components/TopUpdateBar';
import Navbar from './components/Navbar';
import CoverHero from './components/CoverHero';
import FocusGrid from './components/FocusGrid';
import TrackingTimeline from './components/TrackingTimeline';
import DerailRecords from './components/DerailRecords';
import LatestGrid from './components/LatestGrid';
import HotComments from './components/HotComments';
import TrendingTags from './components/TrendingTags';
import SubscribeBox from './components/SubscribeBox';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 flex flex-col">
      <div className="sticky top-0 z-50">
        <TopUpdateBar />
        <Navbar />
      </div>
      <main className="flex-1">
        <CoverHero />
        <FocusGrid />
        <TrackingTimeline />
        <DerailRecords />
        <LatestGrid />
        <HotComments />
        <TrendingTags />
        <SubscribeBox />
      </main>
      <SiteFooter />
    </div>
  );
}